export const API_TABLE = 'API_TABLE';

export const APP_SELECT_CLIENT = 'APP_SELECT_CLIENT';
export const APP_SET_DATE_RANGE = 'APP_SET_DATE_RANGE';
export const APP_SET_SERVICELINE = 'APP_SET_SERVICELINE';
export const APP_SET_PROVIDERTYPE = 'APP_SET_PROVIDERTYPE';
export const APP_SET_REPORT = 'APP_SET_REPORT';
export const APP_SET_MARKET = 'APP_SET_MARKET';
export const APP_SET_PATIENT_TYPE = 'APP_SET_PATIENT_TYPE';
export const APP_SET_AI_QUERY = 'APP_SET_AI_QUERY';
export const APP_SET_QUERY_DATA = 'APP_SET_QUERY_DATA';
export const APP_SET_CHATBOT_STATE = 'SET_CHATBOT_STATE';

export const selectClient = (clientId) => ({
  type: APP_SELECT_CLIENT,
  payload: clientId,
});

export const setDateRange = (config) => ({
  type: APP_SET_DATE_RANGE,
  payload: config,
});

export const setServiceline = (id, parentId) => ({
  type: APP_SET_SERVICELINE,
  payload: {
    id,
    parent_id: parentId,
  },
});

export const setProviderType = (providerType) => ({
  type: APP_SET_PROVIDERTYPE,
  payload: providerType,
});

export const setReport = (report) => ({
  type: APP_SET_REPORT,
  payload: report,
});

export const setMarket = (marketId) => ({
  type: APP_SET_MARKET,
  payload: marketId,
});

/**
 * @param {keyof PatientType} patientType
 */
export const setPatientType = (patientType) => ({
  type: APP_SET_PATIENT_TYPE,
  payload: patientType,
});

// AI chatbot state
export const setChatbotState = (payload) => ({
  type: APP_SET_CHATBOT_STATE,
  payload
});


// AI Query from chatbot
export const setAIQuery = (query)  => ({
  type: APP_SET_AI_QUERY, 
  payload: query 
});

export const queryData = (model, options, type = API_TABLE) => ({
  type,
  request: {
    url: `/AI?model=${model}`,
    method: 'GET',
    params: { opts: options },
  },
});